import { Modal } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';

interface Props {
  onClose: () => void;
}

export const InstructionsModal = ({ onClose }: Props) => {
  return (
    <Modal
      title="How to find and prepare your transactions"
      fullscreen
      primaryLabel="Close"
      secondaryLabel="Read the full documentation"
      onClose={onClose}
      onPrimaryClick={onClose}
      onSecondaryClick={() => {
        window.open(
          'https://support.simplywall.st/hc/en-us/articles/10974593931151',
          '_blank'
        );
      }}
    >
      <Heading as="h3" size="small" className="mb-x1">
        Finding your transactions
      </Heading>
      <p className="m-x0 mb-x3 text-xs">
        Log in to your broker and locate the transaction history (CSV, Excel -
        recommended, or PDF). It&apos;s often found under sections like Reports,
        Settings, or Activity.
      </p>
      <Heading as="h3" size="small" className="mb-x1">
        Preparing your transactions
      </Heading>
      <p className="m-x0 mb-x3 text-xs">
        If using a spreadsheet, open it in Excel or Google Sheets. Here&apos;s a
        few tips:
        <ul className="my-x1 list-disc text-xs [&>li]:my-x0_5 [&>li]:ml-x3">
          <li>
            You can copy and paste multiple values into the table (copying
            entire columns is fastest)
          </li>
          <li>
            Make sure the date format match the date format of the table (you
            can adjust it).
          </li>
          <li>
            Double-check that your stock tickers and exchanges are matched
            correctly
          </li>
        </ul>
      </p>
      <p className="m-x0 mb-x3 text-xs">
        <strong>Note:</strong> Only add Buy &amp; Sell transactions. Dividends,
        stock splits and other corporate events will be automatic.
      </p>
    </Modal>
  );
};
